module.exports = __webpack_public_path__ + "static/media/loan-from-friend-family.b45da3ef.svg";